import {
  ADMIN_YT_AUDITS_LOADED,
  ADMIN_YT_AUDIT_DETAIL_LOADED,
  ADMIN_YT_AUDIT_DETAIL_CLEAR,
  ADMIN_YT_AUDIT_USERS_LOADED,
  ADMIN_YT_AUDITS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import { arriveNotice } from '../noticeActions';

export function adminYtAuditsLoaded(audits, total) {
  return { type: ADMIN_YT_AUDITS_LOADED, payload: { audits, total } };
}
export function adminYtAuditDetailLoaded(audit) {
  return { type: ADMIN_YT_AUDIT_DETAIL_LOADED, payload: { audit } };
}
export function adminYtAuditDetailClear() {
  return { type: ADMIN_YT_AUDIT_DETAIL_CLEAR };
}
export function adminYtAuditUsersLoaded(users) {
  return { type: ADMIN_YT_AUDIT_USERS_LOADED, payload: { users } };
}
export function adminYtAuditsClear() {
  return { type: ADMIN_YT_AUDITS_CLEAR };
}

export function fetchAdminYtAudits(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await api.nestedParamsGet({
        path: 'yt-audit/admin/list',
        version: 'gateway',
        params,
        token: adminToken,
        dispatch,
        isAdminRoute: true,
      });
      const json = api.camelizeKeys(await response.json());
      dispatch(adminYtAuditsLoaded(json.audits, json.total));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function fetchAdminYtAuditDetail(auditId) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await api.nestedParamsGet({
        path: `yt-audit/${auditId}`,
        version: 'gateway',
        params: {},
        token: adminToken,
        dispatch,
        isAdminRoute: true,
      });
      const json = api.camelizeKeys(await response.json());
      dispatch(adminYtAuditDetailLoaded(json));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function fetchAdminYtAuditUsers() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await api.nestedParamsGet({
        path: 'yt-audit/admin/users',
        version: 'gateway',
        params: {},
        token: adminToken,
        dispatch,
        isAdminRoute: true,
      });
      const json = api.camelizeKeys(await response.json());
      dispatch(adminYtAuditUsersLoaded(json.data));
    } catch (e) {
      // non-critical — filter options silently fail
    }
  };
}

export function removeAdminYtAuditChannel(auditId, channelId) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await api.del({
        path: `yt-audit/${auditId}/channel/${encodeURIComponent(channelId)}`,
        version: 'gateway',
        token: adminToken,
        dispatch,
        isAdminRoute: true,
      });
      const json = api.camelizeKeys(await response.json());
      dispatch(adminYtAuditDetailLoaded(json));
      return json;
    } catch (e) {
      dispatch(arriveNotice(e.message));
      return null;
    }
  };
}

export function batchCreateAdminAudits(channels, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const response = await api.post({
        path: 'yt-audit/admin/batch',
        version: 'gateway',
        body: { channels },
        token: adminToken,
        dispatch,
        isAdminRoute: true,
      });
      const json = await response.json();
      if (onSuccess) onSuccess(json);
      return json;
    } catch (e) {
      dispatch(arriveNotice(e.message));
      return null;
    }
  };
}
